import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import * as deviceService from "@common/services/deviceService";
import { fetchBrewery } from "@brewery/actions/breweryActions";

const EditDeviceModal = ({ show, handleClose, serialNumber }) => {
  const [value, setValue] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const breweryList = useSelector((state) => state.brewery?.list);

  useEffect(() => {
    if (show && serialNumber && breweryList) {
      let allDevices = [];
      if (Array.isArray(breweryList)) {
        allDevices = breweryList;
      } else {
        allDevices = [
          ...(breweryList.brew_clean_idle || []),
          ...(breweryList.brew_acid_clean_idle || []),
          ...(breweryList.fermenting || []),
          ...(breweryList.serving || []),
          ...(breweryList.disconnected || []),
        ];
      }
      const device = allDevices.find(
        (d) =>
          d && (d.serial_number === serialNumber || d.uuid === serialNumber),
      );

      let nameToPrefill = device?.custom_name;
      if (!nameToPrefill && device?.title) {
        // Fallback to title if custom_name is not exposed in brewery overview.
        // Ignore default titles like "Keg <uuid>" or just "<uuid>"
        if (
          device.title !== device.uuid &&
          !device.title.startsWith("Keg ") &&
          !device.title.startsWith("Brewer ")
        ) {
          nameToPrefill = device.title;
        }
      }

      if (nameToPrefill) {
        setValue(nameToPrefill);
      } else {
        setValue("");
      }
    } else if (!show) {
      setValue(""); // Reset when modal closes
    }
  }, [show, serialNumber]); // Removed breweryList from deps to prevent overwrite while typing

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const changeDeviceName = async () => {
    setIsSending(true);
    setError(false);
    try {
      await deviceService.editDevice(serialNumber, {
        custom_name: value.trim(),
      });
      dispatch(fetchBrewery());
      handleModalClose();
    } catch (err) {
      setError(true);
    } finally {
      setIsSending(false);
    }
  };

  const handleModalClose = () => {
    setValue("");
    setIsSending(false);
    setError(false);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ textAlign: "center" }}>EDIT DEVICE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <FormGroup controlId="editDevice">
            <ControlLabel>Device name</ControlLabel>
            <FormControl
              type="text"
              value={value}
              placeholder="Enter text"
              onChange={handleChange}
            />
          </FormGroup>
        </Form>
        {isSending && <div>Changing name...</div>}
        {error && <div>Error!</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleModalClose}>Close</Button>
        <Button onClick={changeDeviceName} bsStyle="primary">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDeviceModal;
